export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/publicapi/'
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_MAPS_AKI_KEY || 'AIzaSyC3a8Eh_xxMhktCGerhj7lEFcvgiNDIkwI'
export const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || '0'
export const APP_ENV = process.env.REACT_APP_ENV || 'DEV'